import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom'; // Add this import
import api from '../../services/api';
import { Link } from 'react-router-dom';
import DataGrid, {
  Column,
  Paging,
  Pager,
  FilterRow,
  Selection,
  SearchPanel,
  Toolbar,
  Item,
} from 'devextreme-react/data-grid';
import 'devextreme/dist/css/dx.material.blue.light.compact.css';
import { LoadPanel } from 'devextreme-react/load-panel';
import { Button } from 'devextreme-react/button'; // Add this import

const CompanyList = () => {
  const [companies, setCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const gridWrapperRef = useRef(null);
  const fetchCalled = useRef(false);
  const navigate = useNavigate(); // Add this

  useEffect(() => {
    if (fetchCalled.current) return;
    fetchCalled.current = true;

    setIsLoading(true);

    api.get('/Companies')
      .then((res) => {
        const transformedData = res.data.map((item) => ({
          ...item,
          CompanyID: item.id,
        }));
        setCompanies(transformedData);
      })
      .catch((err) => console.error('Error fetching applicants:', err))
      .finally(() => setIsLoading(false));
  }, []);

  // Handle navigation to create page
  const handleNewCompany = () => {
    navigate('/companies/create');
  };

  const columns = useMemo(
    () => [
      { field: 'companyName', caption: 'Company Name', filterOperations: ['startsWith', 'contains', 'endsWith', '='] },
      { field: 'phoneNo', caption: 'Phone No.', filterOperations: ['startsWith', 'contains', 'endsWith', '='] },
      { field: 'mobileNo', caption: 'Mobile No.', filterOperations: ['startsWith', 'contains', 'endsWith', '='] },
      { field: 'eMail', caption: 'Email', filterOperations: ['startsWith', 'contains', 'endsWith', '='] },
      { field: 'country', caption: 'Country', filterOperations: ['startsWith', 'contains', 'endsWith', '='] },
      { field: 'city', caption: 'City', filterOperations: ['startsWith', 'contains', 'endsWith', '='] },
      { field: 'address', caption: 'Address', filterOperations: ['startsWith', 'contains', 'endsWith', '='] },
      { field: 'companyType', caption: 'CompanyType', filterOperations: ['startsWith', 'contains', 'endsWith', '='] },      
      { field: 'licenseDate', caption: 'License Date' },
      { field: 'registrationDate', caption: 'Reg Date' },
      { field: 'is_Active', caption: 'Active', filterOperations: ['='] },
    ],
    []
  );

  return (
    <div className="w-100 h-100 bg-white rounded p-1" ref={gridWrapperRef}>
      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={{ of: '.dx-datagrid' }}
        visible={isLoading}
        showIndicator={true}
        shading={false}
        showPane={true}
      />

      <DataGrid
        name="_dxGrid"
        dataSource={companies}
        showBorders
        rowAlternationEnabled
        allowColumnResizing
        columnAutoWidth       
        wordWrapEnabled 
        focusedRowEnabled
        showColumnLines
        keyExpr="companyID"
        height="100%"
        width="100%"
      >
        <Toolbar>
          <Item location="before">
            <div className="d-flex align-items-center es-label-title">
              <strong>COMPANIES</strong>               
            </div>
          </Item>
          <Item location="after">
            <Button
              text="New Company"
              type="default"
              icon="add"
              onClick={handleNewCompany}
            />
          </Item>
          <Item name="searchPanel" />          
        </Toolbar>

        <SearchPanel visible highlightCaseSensitive />
        <FilterRow visible />
        <Selection mode="multiple" />
        <Paging defaultPageSize={50} />
        <Pager showPageSizeSelector allowedPageSizes={[15, 25, 50, 100]} showInfo />

        <Column
          caption="Edit"
          width={80}
          cellRender={(data) => <Link to={`/companies/edit/${data.data.companyID}`}>Edit</Link>}
        />

        {columns.map(({ field, caption, filterOperations }) => (
          <Column 
            key={field} 
            dataField={field} 
            caption={caption} 
            allowFiltering
            filterOperations={filterOperations}
            defaultFilterOperation={field === 'is_Active' ? '=' : 'startsWith'}
            lookup={field === 'is_Active' ? {
              dataSource: [
                { value: true, text: 'Checked' },
                { value: false, text: 'Unchecked' }
              ],
              valueExpr: 'value',
              displayExpr: 'text'
            } : undefined}
            customizeText={field === 'licenseDate' || field === 'registrationDate'
              ? (cellInfo) => {
                  if (!cellInfo.value) return '';
                  const date = new Date(cellInfo.value);
                  return isNaN(date.getTime()) ? cellInfo.value : date.toLocaleDateString('en-GB');
                }
              : undefined}
          />
        ))}

      </DataGrid>
    </div>
  );
};

export default CompanyList;